import { Link } from 'react-router-dom';
import s3image1 from '../assets/newabout.jpeg';

function About() {
  return (
    <div
      className="lg:block h-[625px] md:h-[575px] lg:h-[65vh] text-black bg-gray-100 relative overflow-auto"
      id="About"
    >
      <div className="absolute right-0 top-0">
        <div className="hidden lg:block bg-[#FD6721] h-80 w-96 z-0"></div>
      </div>
      <div>
        <p className="font-bold text-5xl text-center pt-8 md:pt-10 mb-3">
          About <span className="text-blue-600">Us</span>
        </p>
        <hr className="border-1 border-blue-300 mx-auto w-16 rounded-md" />
      </div>
      <div className="flex mt-8 md:mt-10 justify-center">
        <div className="w-3/4 lg:w-2/5 h-full lg:mr-20 text-sm md:text-base text-center">
          <p>
            Welcome to Optimal Temp HVAC! We are a trusted, locally owned
            heating and cooling company based right here in Jacksonville, FL,
            dedicated to keeping your home comfortable all year long.
            <br></br>
            <br></br>
            Over the years, we’ve helped countless families stay cool in the
            Florida heat and warm during unexpected cold snaps. That experience
            has taught us what homeowners value most: fast response times,
            transparent pricing, and solutions that are done right the first
            time—no surprises, no stress.
            <br></br>
            <br></br>
            We know choosing the right HVAC contractor can make all the
            difference in your comfort and your energy bills. That’s why we
            focus on delivering high-quality installation, repair, and
            maintenance services that improve efficiency, extend system life,
            and keep your home feeling just the way you like it.
          </p>
        </div>
        <img
          src={s3image1}
          alt="HVAC Maintenance"
          className="h-80 w-1/4 rounded-3xl z-10 hidden lg:inline"
        />
      </div>
    </div>
  );
}

export default About;
